<wl-solar-panels-result-overview-summary-ui
  [rendering]="rendering()"
  [product]="viewModel().product"
  [trackingConfig]="trackingConfig.config"
/>
